// NATIVE 

// INSTALLED 

// CUSTOM 
import { checkingPreload, unCheckingPreload } from '../loading';
import { setCustomersForSelectRedux, setServicesIaUsageDailysListRedux, setServicesIaUsageDailysRedux } from './servicesIaUsageDailysSlice';
import { QueryPagination } from '../../commons/interfaces';
import { 
    getServicesIaUsageDailysAnalyticsService,
    getCustomerOptionsService
} from '../../services/services-ia-usage-dailys.service';

export const getCustomerOptionsStore =
    () =>
    async (dispatch: any) => {
        dispatch(checkingPreload());

        try {
            const response: any = await getCustomerOptionsService();

            if (response.ok) {
                dispatch(setCustomersForSelectRedux(response.data));
            }

            return response;
        } catch (error) {
            console.error(error);

            return error;
        } finally {
            dispatch(unCheckingPreload());
        }
    };


export const getServicesIaUsageDailysAnalyticsStore =
    (query: any = {}) =>
    async (dispatch: any) => {
        dispatch(checkingPreload());

        try {
            const response: any = await getServicesIaUsageDailysAnalyticsService(query);

            if (response.ok) {
                dispatch(setServicesIaUsageDailysListRedux(response.data));
            }

            return response;
        } catch (error) {
            console.error(error);

            return error;
        } finally {
            dispatch(unCheckingPreload());
        }
    };
